/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '@bitcoin-portal/bitcoincom-pkg-components/dist/Modal';
import {
  QrCodeWrapper,
  StyledTitle,
  StyledSubtitle,
  ModalWrapper,
} from '../QrCodeModalV2/styled';
import {
  Wrapper,
  ContentContainer,
  Title,
  IconsContainer,
  AppStoreIcon,
  PlayStoreIcon,
  StyledGatsbyLink,
  QRIcon,
} from './styled';

const FloatingQRIcon = ({ branchLink }) => {
  const { messages } = useIntl();
  const [isVisible, setIsVisible] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      if (scrolled > 10) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleFloatingButtonClick = () => {
    if (window.innerWidth < 768) {
      window.location.href = '/download';
    } else {
      modalRef.current?.open();
    }
  };

  return (
    <>
      <Wrapper
        isVisible={isVisible}
        onClick={handleFloatingButtonClick}
        className="ga-wallet-cta get-app-cta-button-2"
      >
        <QRIcon src="/images/uploads/download.png" alt="QR Code" />
        <ContentContainer>
          <Title>
            <FormattedMessage
              id="global.floating.qr.getApp"
              defaultMessage="Get the app"
            />
          </Title>
          <IconsContainer>
            <PlayStoreIcon
              src="/images/uploads/floatingQRIcon/play-store.svg"
              alt="Get it on Google Play"
            />
            <AppStoreIcon
              src="/images/uploads/floatingQRIcon/app-store.svg"
              alt="Download on App Store"
            />
          </IconsContainer>
        </ContentContainer>
      </Wrapper>
      <ModalWrapper>
        <Modal ref={modalRef}>
          <StyledTitle>{messages['global.qrcodeModal.title']}</StyledTitle>
          <StyledSubtitle>
            {messages['global.qrcodeModal.description']}
          </StyledSubtitle>
          <QrCodeWrapper>
            <div style={{ width: '100%' }}>
              <img
                src="/images/uploads/download.png"
                alt="QR Code to download Bitcoin.com Wallet"
                style={{
                  width: '236px',
                  height: '236px',
                }}
              />
            </div>
          </QrCodeWrapper>
          <StyledGatsbyLink
            to="https://support.bitcoin.com/en/articles/12380851-how-to-scan-a-qr-code"
            target="_blank"
          >
            {messages['global.qrcodeModal.support']}
          </StyledGatsbyLink>
        </Modal>
      </ModalWrapper>
    </>
  );
};

FloatingQRIcon.propTypes = {
  branchLink: PropTypes.string.isRequired,
};

export default FloatingQRIcon;
